import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from '../common/consts/kentico';

class PartnerService {
  async fetchPartners() {
    return Client.items()
      .type(KENTICO_TYPES.PARTNER)
      .toPromise();
  }
}

export default new PartnerService();



// WEBPACK FOOTER //
// ./src/services/Partner.service.js